import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import {
  getIsLoading,
  getIsLoggedIn,
  initSession,
} from 'rdx/auth';
import { Loader } from 'components';
import { navigateToLogin } from '../../utils';

export const useLogin = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const [hasAttemptedLogin, setHasAttemptedLogin] = useState(false);
  const shouldAttemptLogin = !hasAttemptedLogin && !isLoggedIn;

  useEffect(() => {
    if (shouldAttemptLogin) {
      setHasAttemptedLogin(true);
      dispatch(initSession()).catch(navigateToLogin);
    }
  }, [shouldAttemptLogin]);
};

function LoginApp() {
  const loading = useSelector(getIsLoading);
  const isLoggedIn = useSelector(getIsLoggedIn);

  if (loading) return <Loader />;
  if (isLoggedIn) return <Navigate to="/" />;
  return <div> This should not be visible </div>;
}
export default LoginApp;
